
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import State from '../../../../docs/State';
import { Typography, colors } from '@devsisters/ui-admin';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"typography"}}>{`Typography`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import Typography from '@devsisters/ui-admin/lib/Typography';
`}</MDXTag></MDXTag>
<Playground __position={0} __code={'<Typography component=\"title\">제목</Typography>\n<Typography component=\"body\">내용</Typography>\n<Typography component=\"label\">레이블</Typography>'} __scope={{props: this ? this.props : props,State,Typography,colors}}>
  <Typography component="title">
    제목
  </Typography>
  <Typography component="body">
    내용
  </Typography>
  <Typography component="label">
    레이블
  </Typography>
</Playground>
<Playground __position={1} __code={'<Typography component=\"title\">\n  이상 있는 용기가 든 온갖 곳이 힘있다. 꽃이 그러므로 방지하는 광야에서 그들을\n  장식하는 그리하였는가? 끓는 열매를 위하여, 생명을 불러 우리 모래뿐일 뿐이다.\n</Typography>\n<Typography component=\"body\">\n  할지니, 돋고, 고동을 약동하다. 못할 이것은 이상은 그들의 바이며, 구하지\n  부패를 품에 있다. 크고 청춘의 같은 불어 두손을 뿐이다. 않는 꽃이 그들은\n  천자만홍이 찾아 생생하며, 같은 것이다. 얼음이 풀이 충분히 끓는다. 불어\n  풍부하게 대한 공자는 인생을 생명을 얼음과 쓸쓸하랴? 사람은 피어나기 보이는\n  창공에 반짝이는 풀이 낙원을 황금시대다. 남는 돋고, 과실이 두기 그들은 눈에\n  무엇을 가치를 보라. 가는 위하여서, 살 그것은 있음으로써 사라지지 청춘이 피고\n  인생에 듣는다. 우는 이것이야말로 그림자는 할지니, 투명하되 풍부하게 원질이\n  그들은 부패뿐이다.\n</Typography>'} __scope={{props: this ? this.props : props,State,Typography,colors}}>
  <Typography component="title">
    이상 있는 용기가 든 온갖 곳이 힘있다. 꽃이 그러므로 방지하는 광야에서 그들을 장식하는 그리하였는가? 끓는 열매를 위하여, 생명을 불러 우리 모래뿐일 뿐이다.
  </Typography>
  <Typography component="body">
    할지니, 돋고, 고동을 약동하다. 못할 이것은 이상은 그들의 바이며, 구하지 부패를 품에 있다. 크고 청춘의 같은 불어 두손을 뿐이다. 않는 꽃이 그들은 천자만홍이 찾아 생생하며, 같은 것이다. 얼음이 풀이 충분히 끓는다. 불어 풍부하게 대한 공자는 인생을 생명을 얼음과 쓸쓸하랴? 사람은 피어나기 보이는 창공에 반짝이는 풀이 낙원을 황금시대다. 남는 돋고, 과실이 두기 그들은 눈에 무엇을 가치를 보라. 가는 위하여서, 살 그것은 있음으로써 사라지지 청춘이 피고 인생에 듣는다. 우는 이것이야말로 그림자는 할지니, 투명하되 풍부하게 원질이 그들은 부패뿐이다.
  </Typography>
</Playground>
<Playground __position={2} __code={'<div>\n  {colors.map((color, key) => {\n    return (\n      <Typography key={key} color={color}>\n        {color}\n      </Typography>\n    )\n  })}\n</div>'} __scope={{props: this ? this.props : props,State,Typography,colors}}>
  <div>
    {colors.map((color, key) => {
      return (
        <Typography key={key} color={color}>
          {color}
        </Typography>
      );
    })}
  </div>
</Playground>
           </MDXTag>
  }
}
  